import React from 'react';
import { FullBackground } from '../../../components/FullBackground';

type Props = {
  className?: string;
};

export const PDFTestimonial: React.FC<Props> = props => {
  return (
    <>
      <FullBackground color={'bg-gold-200'} isSlanted={false}>
        <div
          style={{ marginLeft: '50vw', marginRight: '50vw' }}
          className={props.className}
        >
          <div className="py-16 lg:py-24 md:mx-10 lg:mx-20 xl:mx-32">
            <div className="relative max-w-xl max-w-7xl">
              <section>
                <div className="md:flex md:flex-col ">
                  <blockquote className="mt-6 md:flex-grow md:flex md:flex-col">
                    <div className="relative text-2xl md:text-3xl lg:text-4xl font-medium text-white md:flex-grow">
                      <p className="relative">
                        &ldquo;With TableTab, it feels like providing a private
                        dining experience to each party.&rdquo;
                      </p>
                    </div>
                    <footer className="mt-8">
                      <div className="flex flex-row">
                        <div className="text-lg  md:text-xl font-medium text-gray-900">
                          Alan,
                        </div>
                        <div className="ml-2 text-lg md:text-xl font-medium text-white">
                          Head Server
                        </div>
                      </div>
                    </footer>
                  </blockquote>
                </div>
              </section>
            </div>
          </div>
        </div>
      </FullBackground>
    </>
  );
};
